import type { Link, NavigateOptions } from '@tanstack/react-router';
import type { ComponentProps } from 'react';

type LinkComponentProps = ComponentProps<typeof Link>;

/**
 * Alvo de navegação vindo de DADO, e não de literal no código.
 *
 * O TanStack Router tipa `to` como a união literal das rotas registradas, o que
 * é excelente para links escritos à mão. Alguns lugares, porém, recebem o
 * caminho de uma estrutura de dados — a configuração do menu lateral, a trilha
 * de navegação e o parâmetro `redirect` da tela de entrada — e ali a checagem
 * literal não tem como se aplicar.
 *
 * Estas duas funções são o ÚNICO ponto do app onde a conversão acontece,
 * concentradas de propósito: um caminho inválido cai no `notFoundComponent`,
 * que é uma tela explicativa, e não numa falha silenciosa.
 */
export function linkTarget(path: string, params?: Record<string, string>): LinkComponentProps {
  return { to: path, params } as unknown as LinkComponentProps;
}

/** Igual a `linkTarget`, para uso com `useNavigate()`. */
export function navigateTarget(path: string, params?: Record<string, string>): NavigateOptions {
  return { to: path, params } as unknown as NavigateOptions;
}
